import React from "react";
import { DateTime } from "luxon";
import { Label } from "@jsq/ds/core";
import { FormTextInput, FormDatePicker } from "@jsq/ds/forms";
import { FieldGroup } from "../common/FieldGroup";
import { MultiInputFormRow } from "../common/MultiInputFormRow";
import { TaxIdInput } from "../TaxIdInput";
import { type IndividualInformationInputProps } from "./types";

export const IndividualInformationInput: React.FC<IndividualInformationInputProps> = ({
  title,
  description,
  meta,
}: IndividualInformationInputProps) => {
  return (
    <FieldGroup title={title} description={description} meta={meta}>
      <MultiInputFormRow>
        <FormTextInput
          key="firstName"
          data-testid="firstName"
          name="firstName"
          label="Name"
          placeholder="First"
          isFullWidth
        />
        <FormTextInput
          key="middleName"
          data-testid="middleName"
          name="middleName"
          label=" " // Empty label to keep the layout consistent
          placeholder="Middle"
          isFullWidth
        />
        <FormTextInput
          key="lastName"
          data-testid="lastName"
          name="lastName"
          label=" " // Empty label to keep the layout consistent
          placeholder="Last"
          isFullWidth
        />
      </MultiInputFormRow>
      <MultiInputFormRow>
        <>
          <Label htmlFor="dateOfBirth">Date of birth</Label>
          <FormDatePicker
            key="dateOfBirth"
            id="dateOfBirth"
            name="dateOfBirth"
            data-testid="dateOfBirth"
            isFull
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={125} // Don't want to age discriminate
            maxDate={new Date()}
            placeholderText="MM/DD/YYYY"
            hasIcon
            data-cy="dateOfBirth"
            filterDate={(date: Date) => {
              // Disallow future dates
              const currentDate = DateTime.local().plus({ days: 1 }).startOf("day");
              return date < currentDate.toJSDate();
            }}
          />
        </>
        <TaxIdInput
          label="Identification number"
          description="Tax ID, Passport Number, Social Security Number, or other government issued unique identification number"
        />
      </MultiInputFormRow>
    </FieldGroup>
  );
};
